import { CampaignService } from '../../typings/campaignService';

export const REVERT_CAMPAIGN_SERVICE_EDITOR = 'REVERT_CAMPAIGN_SERVICE_EDITOR';
export type REVERT_CAMPAIGN_SERVICE_EDITOR = typeof REVERT_CAMPAIGN_SERVICE_EDITOR;

export interface RevertCampaignServiceEditor {
    type: REVERT_CAMPAIGN_SERVICE_EDITOR;
    editorId: string;
    service: CampaignService;
}

export function revertCampaignServiceEditorAction(
    editorId: string,
    service: CampaignService
): RevertCampaignServiceEditor {
    return {
        type: REVERT_CAMPAIGN_SERVICE_EDITOR,
        editorId,
        service
    };
}
